export default __webpack_public_path__ + "static/FoundersGrotesk-Medium-5d772d0b78aabb43ce777f3876cd6e84.woff";